const adminAgentTools = {
  actions: {
    cancel: '取消',
    create: '创建',
    save: '保存',
  },
  bindings: {
    actions: {
      add: '添加 Tool',
      clear: '全部取消',
      clearGroup: '取消全选',
      clearGroupLabel: '取消选择 {{name}} 中当前显示的 Tool',
      collapsePicker: '收起 Tool 选择',
      confirmSelection: '确认选择',
      confirmCurrent: '确认使用最新配置',
      manage: '管理 Tool',
      save: '保存 Tool 选择',
      selectCurrent: '选择当前目录',
      selectCurrentResults: '全选当前结果',
      selectGroup: '全选',
      selectGroupLabel: '全选 {{name}} 中当前显示的可用 Tool',
      viewDetails: '详情',
    },
    empty: '这个 Agent 暂无可选 Tool。',
    exactBindingNotice:
      '这里只保存当前选择的具体 Tool；已选 Tool 会自动采用同一远端身份的最新定义，服务以后新增的 Tool 不会自动启用。',
    exactBindingHelpLabel: '关于 Tool 授权',
    feedback: {
      saved: 'Tool 设置已保存',
    },
    picker: {
      allSources: '全部来源',
      builtin: '内置能力',
      connectionUnknown: '未命名 MCP 服务',
      empty: '没有匹配的 Tool',
      groupSelection: '已选 {{selected}} / {{total}}',
      groupToolCount: '{{count}} 个 Tool',
      noSelection: '尚未选择 Tool',
      resultCount: '共 {{count}} 项',
      searchLabel: '搜索 Tool',
      searchPlaceholder: '搜索 Tool、能力描述或 MCP 服务',
      sourceGroups: 'Tool 来源分组',
      title: '选择 Tool',
      toggleGroup: '展开或收起 {{name}}',
    },
    review: {
      confirmed: '已确认使用这个 Tool 的最新配置。',
      missing: '这个 Tool 已从服务中移除，请取消选择后再保存。',
      required: '这个 Tool 的参数或配置已更新。请查看详情并确认使用最新配置。',
    },
    selectTool: '选择 {{name}}',
    selectionDescription: '按 MCP 服务或能力来源管理这个 Agent 可以调用的 Tool。',
    selectionTitle: 'Tool',
    status: {
      builtin: 'Builtin',
      connectionDisabled: '服务已停用',
      notReady: '暂不可用',
      remoteReadOnlyHint: '远端提示：只读',
      reviewRequired: '配置已更新',
      toolMissing: '当前已不再发现',
      unavailable: '不可用',
    },
    summary: {
      reviewRequired: '待复核 {{count}}',
      selected: '已选 {{count}}',
    },
    validation: {
      definition_missing: '请先移除已经不在当前目录中的 Tool。',
      review_required: '请先确认所有配置已更新的 Tool。',
      tool_name_conflict:
        '已选 Tool 中存在同名调用“{{name}}”。同一 Agent 只能保留其中一个，请取消另一个后再保存。',
    },
    viewerNotice: 'Viewer 只能查看；修改 Agent 的 Tool 设置需要 admin 权限。',
    workspaceLabel: 'Agent Tool 设置',
  },
  connections: {
    actions: {
      confirmDelete: '删除 Connection',
      create: '添加 MCP 服务',
      delete: '删除',
      edit: '编辑',
      refresh: '刷新工具',
      settings: '设置',
    },
    authentication: {
      anonymous: '匿名',
      configured: 'Hub OAuth',
      external: {
        authorized: '外部 OAuth · 已授权',
        authorizing: '外部 OAuth · 授权中',
        disconnected: '外部 OAuth · 未授权',
        error: '外部 OAuth · 授权失败',
        reconnect_required: '外部 OAuth · 需要重新授权',
      },
      headersOnly: '请求头认证',
      incomplete: '认证待完善',
    },
    card: {
      lastRefresh: '最近刷新',
      neverRefreshed: '尚未刷新',
      actions: '{{name}} 的更多操作',
      openDetails: '查看 {{name}} 详情',
      toolCount: 'Tools',
      toolCountValue: '{{count}} 个 Tool',
      updatedAt: '更新于 {{date}}',
    },
    deleteDialog: {
      description: '确认删除“{{name}}”吗？仍被 Agent Binding 引用的 Connection 无法删除。',
      title: '删除 MCP Connection',
    },
    details: {
      authentication: 'Credential',
      configRevision: '配置 revision',
      configuration: '高级设置',
      diagnostics: '连接诊断',
      discoveryGeneration: 'Discovery 代次',
      endpointPolicyRevision: 'Endpoint policy revision',
      errorCode: '最近 error code',
      headerCount: '{{count}} 个',
      lastChecked: '最近检查',
      lastHealthy: '最近健康',
      lastRefresh: '最近刷新',
      none: '无',
      notAvailable: '暂无',
      notConfigured: '未配置',
      protocolVersion: '协议版本',
      resource: 'Resource URI',
      responseBudget: '响应预算（发现 / 执行）',
      requestHeaders: '请求头',
      server: 'Server',
      snapshotId: 'Snapshot ID',
      snapshotRevision: 'Snapshot revision',
      title: 'MCP / {{name}}',
      toolListTitle: '包含 {{count}} 个工具',
      tools: '工具',
      toolSetHash: 'Tool set hash',
    },
    empty: {
      description: '添加一个 MCP 服务即可开始。',
      title: '还没有 MCP 服务',
    },
    feedback: {
      created: 'MCP Connection 已创建',
      deleted: 'MCP Connection 已删除',
      noChanges: 'Connection 配置没有变化',
      oauthAuthorizationStarted: '正在前往 OAuth 授权页',
      oauthAuthorizationTimedOut: 'OAuth 授权等待已超时，请重新授权。',
      oauthAuthorizedAndRefreshed: 'OAuth 授权成功，Tool 列表已刷新。',
      oauthAuthorizedRefreshFailed: 'OAuth 已授权，但 Tool 列表刷新失败，请手动重试。',
      oauthDisconnected: '外部 OAuth 已断开',
      oauthWindowClosed: 'OAuth 授权窗口已关闭，授权尚未完成。',
      oauthReturn: {
        authorized: '外部 OAuth 已授权，可以继续刷新 Tool 列表。',
        authorizing: '外部 OAuth 授权仍在处理中。',
        disconnected: '外部 OAuth 尚未完成授权。',
        error: '外部 OAuth 授权失败，请重试。',
        reconnect_required: '外部 OAuth 需要重新授权。',
      },
      refreshed: 'Discovery 已刷新：新增 {{added}}，变化 {{changed}}，移除 {{removed}}',
      updated: 'MCP Connection 已更新',
    },
    form: {
      authentication: {
        client: 'OAuth client',
        currentClient: '当前 OAuth client',
        currentClientBadge: '当前',
        currentResource: '当前 OAuth Resource',
        description: 'OAuth 与请求头可以同时使用；这里只选择 OAuth 方式。',
        external: {
          automaticDescription:
            '按 MCP 标准优先使用 CIMD/DCR 自动获得 client；适合支持动态注册的服务。',
          authorize: '开始授权',
          callbackUri: 'Callback URI',
          callbackUriCopy: '复制',
          callbackUriCopied: 'Callback URI 已复制。',
          callbackUriCopyFailed: '无法复制 Callback URI。',
          clientId: 'Client ID',
          clientSecret: 'Client Secret',
          clientSecretConfigured: '已配置；留空保留',
          clientSecretHelp:
            '只有服务商签发了 Secret 才填写。Hub 会自动发现 Token 认证方式和 Authorization Server。',
          clientSecretOptional: '可选；填写服务商签发的 Secret',
          confirmDisconnect: '确认断开',
          confirmReauthorize: '重新授权',
          disconnect: '断开',
          disconnectBeforeSwitch: '请先断开当前授权，再切换 OAuth 方式。',
          disconnectDescription: '断开后，需要再次授权才能使用这个 MCP 服务。',
          disconnectTitle: '断开外部 OAuth？',
          reauthorize: '重新授权',
          reauthorizeDescription: '当前授权会先断开，然后重新打开服务授权页。',
          reauthorizeTitle: '重新授权外部 OAuth？',
          preRegisteredDescription: '使用远端服务预先签发的 Client 完成授权。',
          registrationMode: 'Client 注册方式',
          registrationModes: {
            automatic: '自动注册（CIMD / DCR）',
            pre_registered: '预注册 Client',
          },
          status: {
            authorized: '已授权',
            authorizing: '授权中',
            disconnected: '未授权',
            error: '授权失败',
            reconnect_required: '需要重新授权',
          },
          statusLabel: '外部 OAuth 状态',
        },
        headersRemainAvailable: '未启用 OAuth；你仍可在“请求头”中配置 API Key 等凭据。',
        keepCurrent: '保留当前认证',
        loadClientsFailed: 'OAuth client 加载失败，请稍后重试。',
        manageClients: '管理 Clients',
        modes: {
          external: '外部 OAuth',
          hub: 'Hub OAuth',
          none: '不使用 OAuth',
        },
        noClients: '暂无可用的 MCP OAuth client，请先在 Identity 中创建。',
        selectClient: '选择 OAuth client',
        title: '认证',
      },
      createTitle: '添加 MCP 服务',
      editTitle: '编辑 / {{name}}',
      fields: {
        clearCredential: '移除已保存的 credential reference',
        credentialReference: 'Credential reference',
        displayName: '名称',
        enabled: '启用服务',
        endpointUri: '服务端点 URL',
        oauthScopes: 'OAuth scopes',
        resourceUri: 'Resource URI',
      },
      hints: {
        credential:
          '填写受支持的 opaque reference，例如 hub-oidc-client:<record UUID>。已保存的值不会返回浏览器。',
        credentialSaved: '已有 credential reference。留空会保留原值；填写新值会执行轮换。',
        credentialWillClear: '保存后会移除已有 credential reference。',
        enabled: '停用后仍保留 review 历史，但该 Connection 的 Tool 将不可用。',
        enabledShort: '停用后，Agent 将无法使用这个服务。',
        endpoint:
          '支持标准 URL query 参数，并会作为 endpoint 的可见部分保存；token、secret 请使用 OAuth 或请求头。',
        oauthScopes:
          '每行一个真实 scope 名称。scope 来自 Identity/resource 配置，Hub 不会根据 Tool 名自动生成。',
        resource: '可选的绝对 URI，供 Hub 托管的 OAuth execution 使用。',
        targetLocked:
          '首次 discovery 成功后，endpoint 与 resource 即固定。要更换远端身份，请新建 Connection。',
        targetLockedShort: '服务已连接，endpoint 不能再修改。',
      },
      headers: {
        add: '添加请求头',
        configuredPlaceholder: '已配置；留空保留',
        description: '发送到 MCP 服务的额外 HTTP 请求头，可用于 API Key。',
        empty: '尚未配置请求头。',
        keepConfiguredHint: '已有 value 已安全保存；留空会保留，输入新值才会替换。',
        name: '请求头名称',
        remove: '删除请求头 {{name}}',
        title: '请求头',
        value: '请求头值',
      },
      loadingName: '加载中',
      placeholders: {
        displayName: '命名你的 MCP 服务',
      },
      tabs: {
        authentication: '认证',
        headers: '请求头',
        label: 'MCP 连接设置',
      },
      validation: {
        authorizationConflict: '启用 OAuth 时，Authorization 由 OAuth 独占。',
        displayNameRequired: '请输入显示名称。',
        clientRequired: '请选择 OAuth client。',
        endpointRequired: '请输入 endpoint URI。',
        externalClientIdRequired: '请输入远端签发的 Client ID。',
        headerNameDuplicate: '请求头名称不能重复（不区分大小写）。',
        headerNameInvalid: '请求头名称不符合 HTTP token 格式。',
        headerNameRequired: '请输入请求头名称。',
        headerValueInvalid: '请求头值不能包含换行符。',
        headerValueRequired: '新请求头必须填写 value。',
      },
    },
    health: {
      blocked: '已阻止',
      healthy: '健康',
      invalid_response: '响应不合法',
      unknown: '尚未检查',
      unreachable: '无法连接',
    },
    page: {
      description: '连接并管理 MCP 服务。',
      title: 'MCP',
    },
    refreshDialog: {
      confirm: '更新工具列表',
      description:
        '更新会让已绑定 Tool 自动采用最新 definition；新增 Tool 不会自动启用，已移除 Tool 会变为不可用。',
      title: '确认更新 Tool 列表',
    },
    refreshNotice: {
      credentialsChanged: '认证配置已变化，旧的 Tool snapshot 已失效。',
      later: '稍后',
      now: '立即更新 Tool 列表',
    },
    search: {
      clear: '清除搜索',
      empty: '没有找到匹配的 MCP 服务。',
      label: '搜索 MCP 服务',
      placeholder: '搜索名称或 endpoint',
    },
    status: {
      disabled: '已停用',
      enabled: '已启用',
    },
    transport: {
      label: '连接方式',
      streamableHttp: 'Streamable HTTP',
    },
    tools: {
      annotations: '远端 annotations',
      closeDetails: '关闭 Tool 详情',
      definitionId: 'Definition ID',
      definitionRevision: 'Definition revision',
      empty: '当前没有 Tool definition。请先完成 Connection 配置并执行 discovery。',
      inputSchema: 'Input schema',
      inputParameters: '输入参数',
      inputValue: '输入值',
      nestedFieldCount: '{{count}} 个字段',
      noOutputFields: '已声明 {{type}}，但未定义字段。',
      noParameters: '无参数',
      noStructuredOutput: '未声明结构化返回。',
      openDetails: '查看 {{name}} 详情',
      execution: 'Execution metadata',
      executionPolicyRevision: 'Execution policy revision',
      outputSchema: 'Output schema',
      outputParameters: '输出参数',
      outputRequired: '必有',
      readOnlyHintNotice:
        'readOnlyHint 只是远端提供的 review metadata，既不授予权限，也不阻止执行。真正的授权取决于当前 Binding、credential、resource、scopes 与 execution policy。',
      readOnlyHintHelpLabel: '关于远端 readOnlyHint',
      remoteReadOnlyHint: '远端提示：只读',
      required: '必填',
      returnValue: '返回值',
      schemaLimitNotice: '部分更深层或超出展示预算的字段请在技术信息中查看。',
      sourceReference: 'Source reference',
      technicalDetails: '技术信息',
    },
    viewerNotice: 'Viewer 只能查看；修改或刷新 Connection 需要 admin 权限。',
    workspaceLabel: 'MCP Connection 工作区',
  },
  errors: {
    codes: {
      agentNotFound: '所选 Self-Agent App 已不存在。',
      bindingConflict: 'Agent 的 Tool 设置已变化，请重新加载后再试。',
      connectionConflict: '已存在同名 Connection。',
      connectionInUse: '这个 Connection 仍被 Agent Binding 使用。',
      connectionNotFound: 'MCP Connection 已不存在。',
      connectionRevisionConflict: 'Connection 已变化，请重新加载后再试。',
      definitionChanged: '所选 Tool 的配置已更新，请重新加载并确认。',
      discoveryAuthenticationFailed: '远端 MCP Server 拒绝了 discovery 认证。',
      discoveryConnectionFailed: 'Hub 无法连接 MCP Server。',
      discoveryEndpointRejected: 'Endpoint、redirect、DNS 或网络目标未通过安全检查。',
      discoveryInvalidCatalog: 'MCP Server 返回的 Tool 目录不完整或前后矛盾。',
      discoveryInvalidResponse: 'MCP Server 返回了不合法的协议响应。',
      discoveryResponseTooLarge: 'Discovery 响应超过了这个 Connection 的字节预算。',
      discoveryTimeout: 'MCP discovery 超时。',
      discoveryToolsNotSupported: 'MCP Server 不支持 Tool discovery。',
      externalOAuthConfigInvalid: '预注册 OAuth client 配置不完整或组合无效。',
      invalidAgentType: '所选应用不是 Self-Agent App。',
      invalidBindings: '所选 Tool 集合不合法。',
      toolNameConflict: '已选 Tool 中存在同名调用。同一 Agent 只能保留其中一个。',
      oauthAuthorizationUnavailable: '无法启动 OAuth 授权，请检查 endpoint、网络与远端认证配置。',
      oauthAuthorizationDenied: '你取消了授权，或远端拒绝了本次 OAuth 请求。',
      oauthAuthorizationFailed: 'OAuth 授权失败，请检查远端认证配置后重试。',
      oauthClientAuthMethodUnavailable: '远端服务不支持与当前 client 凭据兼容的 Token 认证方式。',
      oauthCredentialUnavailable: 'OAuth credential 无法读取，请重新授权。',
      oauthFlowExpired: 'OAuth 授权记录已过期，请重新发起授权。',
      oauthIssuerMismatch: '配置的 issuer 与 MCP 服务发现到的 Authorization Server 不一致。',
      oauthIssuerUnavailable: '无法安全验证 MCP 服务的 OAuth issuer。',
      oauthNotConfigured: '这个 MCP 服务尚未配置外部 OAuth。',
      oauthResolverUnavailable: 'OAuth discovery 服务当前不可用。',
      targetImmutable: '目标已经成功 discovery；如需更换，请新建 Connection。',
      targetInvalid: 'Endpoint 或 resource URI 不合法或不安全。',
      unknownTool: '所选 Builtin Tool 已不存在。',
      writeForbidden: '当前角色只能查看 Agent Tools。',
    },
    loadBindings: 'Agent 的 Tool 设置加载失败，请稍后重试。',
    loadBindingsTitle: '无法加载 Tool 设置',
    loadConnection: 'MCP Connection 加载失败，请稍后重试。',
    loadConnectionTitle: '无法加载 MCP Connection',
    loadConnections: 'MCP Connection 列表加载失败，请稍后重试。',
    loadConnectionsTitle: '无法加载 MCP Connection',
    loadTargets: 'Self-Agent App 加载失败，请稍后重试。',
    loadTargetsTitle: '无法加载 Agent 选项',
    loadTools: '当前 Tool definition 加载失败，请稍后重试。',
    loadToolsTitle: '无法加载当前 Tools',
    oauthPopupBlocked: '浏览器阻止了 OAuth 授权窗口，请允许弹窗后重试。',
    operationFailed: '操作失败，请检查当前配置后重试。',
  },
  page: {
    description: '管理 Agent 可使用的 MCP 服务与 Tool。',
    title: 'Agent Tools',
  },
  tabs: {
    bindings: 'Agent Binding',
    connections: 'MCP Connection',
  },
}

export default adminAgentTools
